import styled from "@emotion/styled";
import { IconSettings, IconX } from "@tabler/icons-react";
import { Modal, ModalProps, useModal } from "@unlikelyai-magic/ui/modals";
import { Heading } from "@unlikelyai-magic/ui/typography";
import { cn } from "@unlikelyai-magic/utils";
import { useConfiguration } from "../hooks/useConfiguration";
import { ConfigurationView } from "./ConfigurationView";

export const StaticInformationModal = styled(({ className }: ModalProps) => {
  const { closeModal } = useModal();
  const configuration = useConfiguration();

  return (
    <Modal
      className={cn(
        className,
        "mx-auto w-full max-w-2xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl outline outline-1 outline-black/5 transition-all data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      )}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <IconSettings className="size-5" />
          <Heading level="h5" className="mb-0 font-inter">
            Configuration{" "}
            <span className="font-bold">{configuration.title}</span>
          </Heading>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={closeModal}
            className="p-1 text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Configuration"
          >
            <IconX className="size-5" />
          </button>
        </div>
      </div>

      <ConfigurationView configuration={configuration} />
    </Modal>
  );
})`
  border-radius: 0.75rem;
`;
